module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-14-b0165c1b2aeb7286609ebf054a0c26f8.svg";